import api from './api';

// Tenant service
export const tenantService = {
  async list(params = {}) {
    const response = await api.get('/tenants/', { params });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/tenants/', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/tenants/${id}`, payload);
    return response.data;
  },

  async remove(id) {
    // Soft delete: mark inactive
    return this.update(id, { is_active: false });
  },

  async bulkCascadeDelete(tenantIds) {
    await api.delete('/tenants/bulk-cascade', { data: { tenant_ids: tenantIds } });
    return true;
  },
};